import { CONFIG_SITE } from 'constants/index';
import MainLayout from 'layouts/MainLayout';
import { NextSeo } from 'next-seo';
import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

const TermsConditionsPage = () => {
  const DOCUMENT_URL = CONFIG_SITE?.CONTENT?.DOCUMENT_TERMS_AND_CONDITIONS_URL ?? undefined;

  const { data } = useQuery(
    ['markdown-content', 'terms-and-conditions'],
    async () => {
      const response = await axios.get(DOCUMENT_URL);

      return {
        contentType: response?.headers['content-type'],
        data: response.data,
      };
    },
    {
      enabled: !!DOCUMENT_URL,
    }
  );

  return (
    <MainLayout>
      <NextSeo title={`Terms & Conditions | ${CONFIG_SITE?.CONTENT?.COMPANY?.BRAND}`} />
      <section className="section-container">
        {DOCUMENT_URL ? (
          <>
            {!!data && (
              <>
                {data.contentType === 'application/pdf' ? (
                  <div
                    style={{
                      paddingBottom: '56.25%',
                      position: 'relative',
                      display: 'block',
                      width: '100%',
                      minHeight: '500px',
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      src={DOCUMENT_URL}
                      frameborder="0"
                      allowfullscreen=""
                      style={{ position: 'absolute', top: 0, left: 0 }}
                    ></iframe>
                  </div>
                ) : (
                  <ReactMarkdown
                    className="markdown-content"
                    children={data.data}
                    rehypePlugins={[rehypeRaw]}
                    remarkPlugins={[remarkGfm]}
                  />
                )}
              </>
            )}
          </>
        ) : (
          ''
        )}
      </section>
    </MainLayout>
  );
};

export default TermsConditionsPage;
